import { Col, Empty, Row, Skeleton, Typography } from "antd";
import Title from "antd/es/typography/Title";
import React, { useEffect } from "react";
import { StarFilled } from "@ant-design/icons";
import StarProcess from "./StarProgress";
import styles from "../commentStarProgress/commentStarProgress.module.css";
import { useGetRatePublicQuery } from "features/comment/service/comment.service";
import { useAppDispatch } from "app/hooks";
import { setCountRate, setRate } from "features/comment/CommentSlice";
import SmallStarIcon from "library/icons/comment/SmallStarIcon";
import BigStarIcon from "library/icons/comment/BigStarIcon";

const { Text } = Typography;

type Props = {
	average: number;
	number: number;
	isLoading: boolean;
	icon?: any;
	text?: string | undefined;
	style?: React.CSSProperties | undefined;
	dataSource: any[];
	item_type: string;
	item_id: string;
	showReview: () => void;
};

const ListStarProcess = ({
	average,
	icon = <SmallStarIcon />,
	number,
	text,
	isLoading,
	dataSource,
	item_type = "",
	item_id = "",
	style = { height: "100%", width: "100%" },
	showReview,
}: Props) => {
	// const dispatch = useAppDispatch();

	const { data } = useGetRatePublicQuery({
		item_id: item_id,
		item_type: item_type,
	});

	// useEffect(() => {
	// 	if (data) {
	// 		dispatch(setCountRate(data.count_rate));
	// 		dispatch(setRate(data.rate));
	// 	}
	// }, [data]);
	return (
		<div style={style}>
			{isLoading ? (
				<Row style={{ width: "100%" }}>
					<Col span={24} lg={12}>
						<Row
							gutter={[10, 10]}
							justify="start"
							align="middle"
							style={{ margin: 0 }}>
							<Col span={24} md={6}>
								<Skeleton loading={isLoading} active paragraph={{ rows: 1 }} />
							</Col>
							<Col span={24} md={18} className={styles.borderLine}>
								<Skeleton loading={isLoading} active></Skeleton>
							</Col>
						</Row>
					</Col>
				</Row>
			) : dataSource.length <= 0 ? (
				<Empty />
			) : (
				<Row
					gutter={[
						{ md: 40, sm: 24, xs: 24 },
						{ sm: 24, md: 40, xs: 24 },
					]}>
					<Col span={24}>
						<div className="response_col_to_row">
							<Typography.Title
								style={{ margin: "0 0 16px 0", fontWeight: 400 }}
								level={3}>
								Đánh giá và Nhận xét ({data?.count_rate})
							</Typography.Title>
							<span
								onClick={showReview}
								style={{
									padding: 0,
									borderBottom: "1px solid #004B8F",
									color: "#004B8F",
									fontSize: "14px",
									fontWeight: 700,
									cursor: "pointer",
									width: "fit-content",
								}}>
								Viết đánh giá
							</span>
						</div>
					</Col>
					<Col span={24} lg={12}>
						<Row
							gutter={[0, 8]}
							justify="start"
							align="middle"
							style={{ margin: 0 }}>
							<Col span={12} md={6}>
								<div className="value_star_wrapper">
									<Title
										level={2}
										style={{
											margin: 0,
											display: "flex",
											alignItems: "center",
										}}>
										{data?.rate}
										<BigStarIcon
											style={{
												lineHeight: 0.8,
												marginLeft: 8,
												height: 32,
											}}></BigStarIcon>
									</Title>
									<Text>
										{data?.count_rate} {text}
									</Text>
								</div>
							</Col>
							<Col span={12} md={18} className={styles.borderLine}>
								<StarProcess
									key={5}
									percent={data ? data.count_rate_5 : 0}
									number={5}
									icon={icon}
									strokeColor={"#3A393A"}
									status="normal"
									style={{ ...styles }}
								/>
								<StarProcess
									key={4}
									percent={data ? data.count_rate_4 : 0}
									number={4}
									icon={icon}
									status="normal"
									strokeColor={"#3A393A"}
									style={{ ...styles }}
								/>
								<StarProcess
									key={3}
									percent={data ? data.count_rate_3 : 0}
									number={3}
									icon={icon}
									status="normal"
									strokeColor={"#3A393A"}
									style={{ ...styles }}
								/>
								<StarProcess
									key={2}
									percent={data ? data.count_rate_2 : 0}
									number={2}
									icon={icon}
									status="normal"
									strokeColor={"#3A393A"}
									style={{ ...styles }}
								/>
								<StarProcess
									key={1}
									percent={data ? data.count_rate_1 : 0}
									number={1}
									icon={icon}
									status="normal"
									strokeColor={"#3A393A"}
									style={{ ...styles }}
								/>
							</Col>
						</Row>
					</Col>
				</Row>
			)}
		</div>
	);
};

export default ListStarProcess;
